var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGbUnitedKingdomuk(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 45,
    viewBox: "0 0 60 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_188_18595)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60 0H0V45H60V0Z",
    fill: "#012169"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.9688 0L30.0938 16.9688L7.3125 0H0V5.8125L22.5 22.5938L0 39.2812V45H7.5L30 28.2188L52.4062 45H60V39.375L37.5938 22.6875L60 6V0H52.9688Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.25 26.3438L0 41.25V45L25.4062 26.3438H20.25ZM37.5 28.2188L36.9375 31.5L54.9375 45H60L37.5 28.2188ZM0 0V0.28125L23.3438 17.9062L23.1562 13.7812L4.6875 0H0ZM60 0L37.5938 16.5H43.2188L60 3.9375V0Z",
    fill: "#C8102E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4062 0V45H22.4062V0H37.4062ZM60 15V30H0V15H60Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 18.0938V27.0938H0V18.0938H60ZM34.4062 0V45H25.4062V0H34.4062Z",
    fill: "#C8102E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_188_18595"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 45,
    fill: "white",
    transform: "matrix(-1 0 0 1 60 0)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGbUnitedKingdomuk);
export default __webpack_public_path__ + "static/media/gb United Kingdom uk.d5622589e52badbd4e3e6fef9a673d92.svg";
export { ForwardRef as ReactComponent };